import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "./components/site/Nav";
import Hero from "./components/site/Hero";
import About from "./components/site/About";
import Services from "./components/site/Services";
import Experience from "./components/site/Experience";
import AIInnovation from "./components/site/AIInnovation";
import Impact from "./components/site/Impact";
import HowAndWhy from "./components/site/HowAndWhy";
import Engage from "./components/site/Engage";
import Footer from "./components/site/Footer";

const Home = () => {
  return (
    <main data-testid="home-page" className="bg-[#050505] text-[#F5F5F0]">
      <Nav />
      <Hero />
      <About />
      <Services />
      <Experience />
      <AIInnovation />
      <Impact />
      <HowAndWhy />
      <Engage />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
